import { useCartStore } from '@/store/cartStore';
import { ShoppingBag01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { Sheet, SheetContent } from '../ui/sheet';
import { CheckoutForm } from './CheckoutForm';

export function CartSheet() {
  const isOpen = useCartStore(s => s.isOpen);
  const closeCart = useCartStore(s => s.closeCart);
  const items = useCartStore(s => s.items);

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      closeCart();
    }
  };

  const handlePointerDownOutside = (e: Event) => {
    if (e.target instanceof Element && e.target.closest('.pac-container')) {
      e.preventDefault();
    }
  };

  return (
    <Sheet open={isOpen} onOpenChange={handleOpenChange}>
      <SheetContent
        className="w-full sm:max-w-xl flex flex-col bg-[var(--dispensary-gray-50)] overflow-y-auto overflow-x-hidden"
        onPointerDownOutside={handlePointerDownOutside}
        onInteractOutside={handlePointerDownOutside}
      >
        <div className="flex items-center justify-center relative py-4 border-b">
          <button
            className="absolute left-4 top-1/2 -translate-y-1/2 md:hidden"
            aria-label="Back"
            onClick={closeCart}
          >
            <svg
              width="24"
              height="24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <span className="text-xl font-bold font-roca text-center w-full">
            Medication Tray
          </span>
        </div>

        {items.length > 0 ? (
          <div className="flex-1 overflow-y-auto py-3">
            <CheckoutForm />
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center h-full">
            <HugeiconsIcon
              icon={ShoppingBag01Icon}
              size={40}
              className="text-muted-foreground mb-3"
            />
            <p className="text-sm text-muted-foreground">
              Your medication tray is empty
            </p>
          </div>
        )}
      </SheetContent>
    </Sheet>
  );
}
